import { MultiPanelDialog } from '../../common/components/MultiPanelDialog'
import { NetworkStatusBadge } from '../components/NetworkStatusBadge'
import { Chain } from '../types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { cn } from '@/ui/utils/style'

export interface SelectNetworkDialogViewProps {
  chains: Chain[]
}

export function SelectNetworkDialogView({ chains }: SelectNetworkDialogViewProps) {
  return (
    <MultiPanelDialog className="sm:gap-6">
      <DialogTitle>Select network</DialogTitle>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3.5">
        {chains.map((chain) => (
          <button
            className={cn(
              'flex flex-col items-center justify-center',
              'relative isolate rounded-[10px] border border-primary',
              'h-[120px] cursor-pointer transition-colors sm:h-[160px]',
              'focus-visible:border-transparent focus-visible:outline-hidden focus-visible:ring-3 focus-visible:ring-primary-200 focus-visible:ring-offset-0',
              !chain.selected && 'hover:border-brand-tertiary',
              chain.selected && 'border-system-success-secondary',
              !chain.selected && chain.isInSwitchingProcess && 'border-brand-tertiary',
            )}
            onClick={() => chain.onSelect()}
            key={chain.name}
          >
            <div
              className={cn(
                'absolute flex flex-col items-center gap-2 transition-transform delay-300 duration-300 sm:gap-3',
                (chain.selected || chain.isInSwitchingProcess) && '-translate-y-3 sm:-translate-y-4',
              )}
            >
              <img src={chain.logo} className="size-8" />
              <div className="typography-label-2">{chain.name}</div>
            </div>
            <NetworkStatusBadge
              status="connected"
              className={cn(
                'absolute opacity-0 transition-all delay-300 duration-300',
                chain.selected && 'translate-y-9 opacity-100',
              )}
            />
            <NetworkStatusBadge
              status="pending"
              className={cn(
                'absolute translate-y-5 opacity-0 transition-all delay-300 duration-300',
                chain.isInSwitchingProcess && 'translate-y-9 opacity-100',
              )}
            />
          </button>
        ))}
      </div>
    </MultiPanelDialog>
  )
}
